import {
  Box,
  BoxProps,
  IconButton,
  Stack,
  TabPanelProps,
  Td,
  Th,
  Tr,
} from '@chakra-ui/react';
import { useFetchAccountsQuery } from 'api';
import { AccountResponse } from 'api/bindings/AccountResponse';
import { SubAccountResponse } from 'api/bindings/SubAccountResponse';
import { usePagination } from 'core';
import { AppTable } from 'features/table';
import { useMemo, useState } from 'react';
import { FiPenTool } from 'react-icons/fi';
import { CreateAccountDrawer } from './CreateAccountDrawer';
import { EditAccountDrawer } from './EditAccountDrawer';
import { AppButton } from 'features/components';

export interface ClientAccountsPageProps extends BoxProps {}

const LoadingBody = () => (
  <Tr>
    <Td colSpan={100}>Loading Accounts...</Td>
  </Tr>
);
export const ClientAccountsPage = (props: ClientAccountsPageProps) => {
  const { ...rest } = props;

  // State
  const [pagination, setPagination] = usePagination();
  const [editingAccount, setEditingAccount] = useState<AccountResponse>();
  //   const [editingSubAccount, setEditingSubAccount] = useState<SubAccountResponse>();
  const [creatingAccountMode, setCreatingAccountMode] = useState<any>();
  //   const [creatingSubAccountMode, setCreatingSubAccountMode] = useState<any>();

  // Fetches
  const {
    isLoading,
    data: accounts,
    refetch,
  } = useFetchAccountsQuery({
    ...pagination,
  });

  const body = useMemo(() => {
    if (isLoading) {
      return <LoadingBody />;
    } else {
      return (
        <>
          {accounts?.items.map((acct, i) => (
            <Tr key={i}>
              <Td>
                <IconButton
                  icon={<FiPenTool />}
                  aria-label="Edit Account"
                  onClick={() => setEditingAccount(acct)}
                />
              </Td>
              <Td>{acct.code}</Td>
              <Td>{acct.name}</Td>
              <Td>{acct.description}</Td>
            </Tr>
          ))}
        </>
      );
    }
  }, [accounts?.items, isLoading]);

  // Return
  return (
    <Box {...rest}>
      {creatingAccountMode && (
        <CreateAccountDrawer
          isOpen={true}
          onClose={() => setCreatingAccountMode(undefined)}
          size="xl"
        />
      )}
      {editingAccount && (
        <EditAccountDrawer
          account={editingAccount}
          onClose={() => setEditingAccount(undefined)}
          isOpen={true}
          refetch={refetch}
          size="xl"
        />
      )}
      <Stack spacing={4}>
        <AppTable
          title="Chart of Accounts"
          buttonGroup={(props) => (
            <AppButton
              leftIcon={<FiPenTool />}
              onClick={() => setCreatingAccountMode(true)}
              variant={'solid'}
            >
              New Account
            </AppButton>
          )}
          pagination={{
            ...pagination,
            itemCount: Number(accounts?.itemCount ?? 0),
            pageCount: Number(accounts?.pageCount ?? 1),
          }}
          onPaginationChange={setPagination}
          header={
            <>
              <Tr>
                <Th></Th>
                <Th>Code</Th>
                <Th>Name</Th>
                <Th>Description</Th>
              </Tr>
            </>
          }
          body={body}
        />
      </Stack>
    </Box>
  );
};
